import React from 'react';

export const IconLocation = () => {
    return (
        <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.5 0.5C2.46263 0.5 0 2.85069 0 5.75C0 6.89166 0.392104 7.93925 1.04385 8.79719C1.05554 8.81775 1.05737 8.84072 1.07067 8.86041L4.73733 14.1104C4.90738 14.3539 5.19383 14.5 5.5 14.5C5.80617 14.5 6.09263 14.3539 6.26267 14.1104L9.92933 8.86041C9.94285 8.84072 9.94446 8.81775 9.95615 8.79719C10.6079 7.93925 11 6.89166 11 5.75C11 2.85069 8.53738 0.5 5.5 0.5ZM5.5 7.5C4.48754 7.5 3.66667 6.71644 3.66667 5.75C3.66667 4.78356 4.48754 4 5.5 4C6.51246 4 7.33333 4.78356 7.33333 5.75C7.33333 6.71644 6.51246 7.5 5.5 7.5Z"
                fill="#BB9056"/>
        </svg>
    );
};